import React, { useEffect, useState } from "react";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ReactComponent as HpgclIcon } from "../../icons/cerc-dashboard.svg";
import { ReactComponent as BankingAalytics } from "../../icons/dashboard/bankingAnalytics.svg";
import { ReactComponent as ConsumptionAndGenerationAnalytics } from "../../icons/dashboard/consumptionAndGenerationAnalytics.svg";
import { ReactComponent as DemandForecasting } from "../../icons/dashboard/demandForecasting.svg";
import { ReactComponent as DiscomAnalysis } from "../../icons/dashboard/discomAnalysis.svg";
import { ReactComponent as ExchangeAnalysis } from "../../icons/dashboard/exchangeAnalysis.svg";
import { ReactComponent as GridFrequencyProfile } from "../../icons/dashboard/gridFrequencyProfile.svg";
import { ReactComponent as MarketMonitoring } from "../../icons/dashboard/marketmonitoring.svg";
import { ReactComponent as PowerAtlas } from "../../icons/dashboard/powerAtlas.svg";
import { ReactComponent as PriceForecasting } from "../../icons/dashboard/priceForecasting.svg";
import { ReactComponent as Upload } from "../../icons/upload.svg";

import { getSessionValidity } from "../../Rest_api/RestApi";
import { COLOR_CODES, isMobile } from "../../common";
import { RuvnlTitle } from "./components";
import { ReactComponent as AnalyticsIcon } from "../../icons/analytics.svg";
import { ReactComponent as AnalyticsSelectedIcon } from "../../icons/analytics-selected.svg";
import { ReactComponent as DashboardIcon } from "../../icons/dashboard.svg";
import { ReactComponent as DashboardSelectedIcon } from "../../icons/dashboard-selected.svg";
import { OverviewDas } from "./Overview/OverviewDas";
import { DynamicDatePicker } from "../../components/DatePicker";
import Hamburger from "../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../icons/gnai_logo.svg";


import { redirectToLogin } from "../Protected";
import { Zap } from "lucide-react";
import { IconTab } from "../../components/IconTab";
import { PageHeader } from "../../components/Page";
function RajDashboardItem({
  title,
  Icon,
  to,
}: {
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  to: string;
}) {
  return (
    <NavLink to={`${to}`} className="dashboard-item">
      <Icon
        width={80}
        height={33}
        style={{
          fill: COLOR_CODES.primary,
        }}
      />
      <p>{title}</p>
    </NavLink>
  );
}

export default function RajDashboard() {
  useEffect(() => {
    localStorage.removeItem("procurement_edit_id");
    getSessionValidity().then((res) => {
      if (res.status === false) {
        redirectToLogin(window.location.href);
      }
    });
  }, []);

  // Use searchParams to get and set the 'tab' query parameter
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") || "analytics";
  const [selectedTab, setSelectedTab] = useState(initialTab);

  // Sync state with query parameter changes
  useEffect(() => {
    const tab = searchParams.get("tab") || "analytics";
    if (tab !== selectedTab) {
      setSelectedTab(tab);
    }
  }, [searchParams, selectedTab]);

  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    if (tab === "vidyutai") {
      navigate("/demo/exchangeAnalysis?module=Vidyut+AI");
      return;
    }
    setSelectedTab(tab);
    setSearchParams({ tab });
  };

  const [dates, setDate] = useState({
    startDate: new Date("2025-01-06"),
    endDate: new Date("2025-01-13"),
    key: "selection",
  });

  return (
    <div className="page-wrapper">
      <PageHeader
        leftComponent={
          <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
            <GNAiIcon width={80} />
            {!isMobile && <Hamburger />}
            <IconTab
              tabs={[
                { key: "analytics", icon: AnalyticsIcon, selectedIcon: AnalyticsSelectedIcon },
                { key: "dashboard", icon: DashboardIcon, selectedIcon: DashboardSelectedIcon },
              ]}
              selected={selectedTab}
              onChange={handleTabChange}
            />
            {isMobile && (
              <h1 className="text-xl font-semibold tracking-wide text-gray-800">
                Vidyut AI - RUVITL
              </h1>
            )}
          </div>
        }
        middleComponent={
          <div className="flex flex-row justify-center items-center space-x-2">
            <h1 className="text-[#6F6D7C] !text-[18px]"> Power Analytics</h1>
          </div>
        }
        rightComponent={
          <div className="md:min-w-[300px]">
            {selectedTab === "analytics" && (
              <DynamicDatePicker
                setDate={(date) => setDate(date[0]!)}
                defaultDates={dates}
              />
            )}
          </div>
        }
      />

      {selectedTab === "analytics" ? (
        <div className="page-wrapper">
          <OverviewDas dates={dates} />
        </div>
      ) : (
        <div className="dashboard-item-container">
          <div className="flex flex-col justify-between h-full">
            <div className="flex flex-row flex-wrap gap-5 justify-center">
              <RajDashboardItem
                Icon={PowerAtlas}
                title="Overview"
                to="compare"
              />
              <RajDashboardItem
                Icon={DemandForecasting}
                title="Demand Analytics"
                to="demand"
              />
              <RajDashboardItem
                Icon={ConsumptionAndGenerationAnalytics}
                title="Generation Analytics"
                to="generation"
              />
              <RajDashboardItem
                Icon={ExchangeAnalysis}
                title="Power Procurement"
                to="procurement"
              />
              <RajDashboardItem
                Icon={ExchangeAnalysis}
                title="Exchange Analytics"
                to="exchangeAnalysis"
              />
              <RajDashboardItem
                Icon={BankingAalytics}
                title="GNA-TGNA Allocation Optimizer"
                to="optimizer"
              />
              <RajDashboardItem
                Icon={ExchangeAnalysis}
                title="PowerMarketizer"
                to="procurementOptimization"
              />
              <RajDashboardItem
                Icon={BankingAalytics}
                title="Merit Engine"
                to="merit_engine"
              />

              {/* <RajDashboardItem
                Icon={BankingAalytics}
                title="Automation"
                to="automation"
              /> */}
              {/* <RajDashboardItem
                Icon={BankingAalytics}
                title="TAM and DEEP"
                to="auctions"
              /> */}
              <RajDashboardItem Icon={Upload} title="Upload Data" to="upload" />
              <RajDashboardItem
                Icon={GridFrequencyProfile}
                title="Transactions"
                to="procurementTable"
              />
            </div>
            <div className="gna-footer-container mt-8">
              <div className="grid grid-cols-3 justify-between items-center gap-5 ">
                <h3 className="text-[#9f9f9f] font-medium text-[13px]">
                  GNA Energy Data and Analytics Capability Center (GDACC)
                </h3>
                <p className="gna-footer-text text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text text-end">
                  Demo Version
                </strong>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export const TabSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab") || "dashboard";

  const handleTabChange = (newTab: string) => {
    navigate(`/demo?tab=${newTab}`);
  };

  return (
    <IconTab
      tabs={[
        { key: "analytics", icon: AnalyticsIcon, selectedIcon: AnalyticsSelectedIcon },
        { key: "dashboard", icon: DashboardIcon, selectedIcon: DashboardSelectedIcon },
      ]}
      selected={tab}
      onChange={handleTabChange}
    />
  );
};

export const DemoVidyutAiButton: React.FC = () => {
  const location = useLocation();
  const isVidyutAiOpen =
    location.pathname === "/demo/exchangeAnalysis" &&
    new URLSearchParams(location.search).get("module") === "Vidyut AI";

  if (isVidyutAiOpen) return null;

  return (
    <NavLink
      to="/demo/exchangeAnalysis?module=Vidyut+AI"
      title="Vidyut AI"
      className="fixed bottom-5 right-5 z-[300] flex items-center gap-2 px-3 py-2 rounded-full text-xs font-medium text-white/80 hover:text-white transition-all duration-200"
      style={{
        background: "rgba(15, 32, 39, 0.85)",
        border: "1px solid rgba(241,147,92,0.25)",
        boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
        backdropFilter: "blur(8px)",
      }}
    >
      <Zap size={13} className="text-[#f1935c]" fill="#f1935c" />
      <span className="tracking-wide">Vidyut AI</span>
    </NavLink>
  );
};

